import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { NewTaskSubTaskList } from 'shared/components/connected/sub-tasks-list';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { PageLoader } from 'shared/components/ui/page-loader';
import { Tooltip } from 'shared/components/ui/tooltip';
import { getIsMacOs } from 'shared/utils/get-is-mac-os';

import { CreateMain } from './components/create-main';
import { TaskDescription } from './components/task-description';
import * as Styled from './task-create.style';

const noop = () => {};

export type LoadingTaskDetailProps = {
  name: string;
  updateName: (name: string) => void;
  onClose: () => void;
  noBreakpoints?: boolean;
};

export const LoadingTaskCreate: React.FC<LoadingTaskDetailProps> = ({
  name,
  updateName,
  onClose,
  noBreakpoints,
}) => {
  const saveButtonRef = useRef<HTMLButtonElement>(null);
  const { t } = useTranslation();
  const isMac = getIsMacOs();

  return (
    <Styled.Container>
      <Styled.Body $noBreakpoints={!!noBreakpoints}>
        <Styled.Main>
          <Styled.MainBody $paddingTop>
            <CreateMain
              name={name}
              updateName={updateName}
              onNewGoal={noop}
              onNewTag={noop}
              onPremium={noop}
            />
            <Styled.BodyContent>
              <Styled.DescriptionContainer>
                <TaskDescription
                  description={''}
                  updateDescription={noop}
                  instantUpdate
                />
              </Styled.DescriptionContainer>

              <Styled.SubTaskListContainer>
                <NewTaskSubTaskList
                  subTasks={[]}
                  onChangeSubTasks={noop}
                  updateNewSubTask={noop}
                />
              </Styled.SubTaskListContainer>
            </Styled.BodyContent>
          </Styled.MainBody>
        </Styled.Main>

        <Styled.SidePanel $noBreakpoints={!!noBreakpoints}>
          <PageLoader />
        </Styled.SidePanel>
      </Styled.Body>

      <Styled.Footer>
        <Button
          variant={Variants.Contained}
          size={Sizes.Medium}
          onClick={onClose}
          color={Colors.Inherit}
        >
          {t('general.labels.cancel')}
        </Button>
        {isMac && (
          <Tooltip
            label={
              <Styled.TooltipContent>
                {t('general.labels.create-task')}{' '}
                <Styled.TooltipContentButton $wide={!isMac}>
                  {isMac ? '⌘' : 'CTRL'}
                </Styled.TooltipContentButton>{' '}
                <Styled.TooltipContentButton>⏎</Styled.TooltipContentButton>
              </Styled.TooltipContent>
            }
            referenceElement={saveButtonRef}
          />
        )}
        <Button
          ref={saveButtonRef}
          variant={Variants.Contained}
          size={Sizes.Medium}
          color={Colors.Primary}
          disabled
        >
          {t('general.labels.save')}
        </Button>
      </Styled.Footer>
    </Styled.Container>
  );
};
